<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tlpWTR/tc-custom/9781955518383.jpg?1730689895949" alt="This image is the cover for the book Valkyrie Condemned, Valkyries Rising"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Valkyrie Condemned, Valkyries Rising
      </h1>
      <p class="bookDescription body article font2">
        <b>Mia</b><br/><br/><b>I left the violence of my father’s world—the underworld he controlled—behind the moment I was an adult. I had no idea that the destiny waiting for me was even darker.</b><br/><br/>I’m happy running my comic shop, renting the room upstairs to an adorably naïve priest in training, and pretending to be bothered when Dad’s oh-so-sexy right-hand man stops by to check on me every few weeks.<br/><br/><b>But then the dreams start.</b> A woman who looks like she could kill Thac—my self-appointed bodyguard—with a glare tells me I’m destined to be a Valkyrie. Caleb—the righteous man living in my attic—manifests powers of his own. And I realize I’ve tumbled into a world I never could’ve imagined.<br/><br/>Along with my Valkyrie sisters, I’ve been called on to do war against an old god. The main of faith and the ancient being who seem to worship me will either be my biggest allies, or my downfall. If they clash with each other, <b>if all three of us can’t come together to fight with my new Valkyrie sisters, the world will burn.</b><br/><br/><i>Valkyries Rising is a #WhyChoose series where the heroine doesn’t have to pick just one mate. In these pages you'll find strong heroines who don’t back down, and the shifters, gods, dragons, and other immortals who love them and fight by their sides.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Allyson Lindt
      </h2>
      
      <p class="authorDescription body article"><b><i>USA Today Bestselling Author</i></b> Allyson Lindt is a full-time geek and a fuller-time author. She likes her stories with sweet geekiness and heavy spice, and loves a sexy happily-ever-after. Because cubicle dwellers need love too.<br><br>Her #GeekLove Contemporary and Ménage Romance books all take place in the same contemporary world. While each series stands on its own, readers' favorite characters, businesses, and places make appearances in other series.<br><br>You can connect with Allyson at her website:<b> http://www.allysonlindt.co/</b> <br><br>Read all of her books to see why <i>A Lust for Reading</i> said her books made them <b>"smile and literally laugh out loud"</b>, <i>Revenge of the Feels</i> loved the <b>sizzling attraction, ...danger, betrayal and humor"</b> and readers call them <b>"book nirvana"</b>,<b>"geek hotness"</b>, <b>"sexy"</b> and <b>"fast paced"</b>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Acelette Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e13783fa